import script from "./MediaPlayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./MediaPlayer.vue?vue&type=script&setup=true&lang=ts"

import "./MediaPlayer.vue?vue&type=style&index=0&id=4c90dff7&lang=scss"

const __exports__ = script;

export default __exports__